import axiosInstance from "../api/axiosInstance";
import { CHECKER_PANEL } from "../constants/API_URLs";

export const getCheckPanel = (params: any): Promise<any> => {
  return axiosInstance.get(CHECKER_PANEL, { params });
};

export const updateCheckPanel = (id: any, data: any): Promise<any> => {
  return axiosInstance.patch(`${CHECKER_PANEL}/${id}`, data);
};
